export default __webpack_public_path__ + "static/media/cp_geo_xk.d782f642.svg";